import gql from 'graphql-tag';

export const GET_REGIONS = gql`
  query {
    regions {
      id
      name
    }
  }
`;

export const GET_REGION = gql`
  query Region($regionId: ID!) {
    region(regionId: $regionId) {
      id
      name
    }
  }
`;

export const GET_CLUBS = gql`
  query Clubs($regionId: ID!) {
    clubs(regionId: $regionId) {
      id
      name
    }
  }
`;

export const GET_CLUB = gql`
  query Club($clubId: ID!) {
    club(clubId: $clubId) {
      id
      name
    }
  }
`;

export const GET_MEMBERSHIPS = gql`
  query Memberships($clubId: ID!) {
    memberships(clubId: $clubId) {
      id
      membershipExternalId
      active
      ospAvailable
      dspAvailable
      isDefault
      priority
      price
      title
    }
  }
`;

export const GET_CLUB_LANGUAGES = gql`
  query ClubLanguages($clubId: ID!) {
    clubLanguages(clubId: $clubId) {
      id
      code
      name
    }
  }
`;

export const GET_MEMBERSHIP_DATA = gql`
  query Membership($membershipExternalId: ID!, $clubId: ID!, $regionId: ID!) {
    membership(membershipExternalId: $membershipExternalId, clubId: $clubId) {
      id
      membershipExternalId
      active
      ospAvailable
      dspAvailable
      isDefault
      priority
      texts {
        id
        title
        description
        termsAndConditions
        language {
          id
          code
          name
        }
      }
    }
    club(clubId: $clubId) {
      id
      name
    }
    region(regionId: $regionId) {
      id
      name
    }
  }
`;

export const UPDATE_MEMBERSHIP = gql`
  mutation Membership($data: UpdateMembershipInput!, $clubId: ID!) {
    updateMembership(data: $data, clubId: $clubId) {
      id
      membershipExternalId
      active
      priority
      texts {
        id
        title
        description
        termsAndConditions
        language {
          id
          code
          name
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/MembershipsPage/graphql/index.ts